export default class HigherOrderStepData {
    constructor(y=0, size=1, orientation=0) {
        this.module = null;
        this.orientation = orientation; // how the triangle is oriented 0-4
        this.size = size; // how big the triangle is
        this.y = y;
    }

    getJson() {
        return {
            module: this.module && this.module.id,
            orientation: this.orientation,
            size: this.size,
            y: this.y,
            x: this.x
        };
    }

    fromJson(json, sequencerEngine) {
        this.x = json.x;
        this.y = json.y;
        this.orientation = json.orientation;
        this.size  = json.size;
        this.module = json.module && sequencerEngine.subSequences.find(
            m => m.id === json.module);
    }
}
